import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'order',
    serviceName: 'auth',
    query: gql`
      query getOrder($ids: [String], $for_admin: Int) {
        order(ids: $ids, for_admin: $for_admin) {
          data {
            description
            sys_description
          }
        }
      }
    `,
  },
  update: {
    name: 'updateOrder',
    serviceName: 'auth',
    query: gql`
      mutation updateOrder($ids: [String]!, $call_me: Int, $sys_description: String) {
        updateOrder(ids: $ids, call_me: $call_me, sys_description: $sys_description) {
          model {
            id
          }
          influenced_count
          messages
        }
      }
    `,
  },
};

export default schema;
